'use client';

import { FC } from 'react';

import { useContentfulLiveUpdates } from '@contentful/live-preview/react';
import { Accordion, Container, Heading, Spacer } from '@purpur/library';

import { RichTextContent } from '@telialt/common-rich-text-content/src/RichTextContent';

import { BlockFaqType } from '../../models/Content';
import { getBlockId } from '../../utils/content';
import { BlockWrapper } from './BlockFaq.styles';
import { transformBlockFaq } from './transformers';

type Props = {
    contentItem: BlockFaqType;
    skipContentfulLiveUpdates?: boolean;
};

export const BlockFaq: FC<Props> = ({ contentItem: initialContentItem, skipContentfulLiveUpdates }) => {
    const contentItem = useContentfulLiveUpdates(initialContentItem, { skip: skipContentfulLiveUpdates });
    const transformedContentItem = transformBlockFaq(contentItem);
    const isNegative = transformedContentItem.colorOption === 'color-dark-purple';

    return (
        <BlockWrapper $isNegative={isNegative} id={getBlockId(contentItem)}>
            <Container>
                <Heading tag="h2" variant="display-15" negative={isNegative}>
                    {transformedContentItem.title}
                </Heading>
                <Spacer height="sm" />
                <Accordion negative={isNegative}>
                    {transformedContentItem.items.map((item) => (
                        <Accordion.Item title={item.title} key={item.id}>
                            <RichTextContent isNegative={isNegative} richText={item.content} />
                        </Accordion.Item>
                    ))}
                </Accordion>
            </Container>
        </BlockWrapper>
    );
};
